export const API_ENDPOINTS = {
  CARD_USER_API_NAME: "CardUserApi",
  EPLATA_CUSTOMER_API: "EplataCustomerApi",
  EPLATA_PROSPECT_API: "EplataProspectApi",
  EPLATA_PUBLIC_API: "EplataPublicApi",
  PATHS: {
    GROUPS: "/app/groups?username=",
    CUSTOMER_ME: "/customer/me",
    PROSPECT_ME: "/prospect/me",
    CONTRACTS: "/customer/contracts?docType=",
    ATTEMPTS: "/app/auth/attempts",
    UPDATED_CUSTOMER_SESSION: "/customer/auth/session",
    UPDATED_PROSPECT_SESSION: "/prospect/auth/session",
    KYCPROSPECT: "/prospect/kyc/update/v2",
    KYCCUSTOMER: "/customer/kyc/update/v2",
    PROSPECT_DOCUMENTS_UPLOAD: "/prospect/file/register",
    CUSTOMER_DOCUMENTS_UPLOAD: "/customer/file/register",
    PROSPECT_GET_DOCUMENTS: "/prospect/documents",
    CUSTOMER_GET_DOCUMENTS: "/customer/documents",
    CUSTOMER_PROFILE: "/customer/profile",
    CREATE_PAYEE: "/customer/payee/create",
    PAYEE_LIST: "/customer/payee/list",
    PAYEE_ARCHIVE: "/customer/payee/archive",
    ACCOUNT_BALANCE_LIST: "/customer/account/balance/list",
    PAYEE_SEARCH: "/customer/payee/search?name=",
    TOKEN_SEND: "/customer/token/send",
    CREATE_TRANSACTION: "/transaction/create/v2",
    GET_BANK_NAME: "/bank/clabe/",
    VERIFY_TOKEN: "/customer/token/verify",
    CLEAR_PROSPECT_SESSION: "/prospect/auth/session",
    CLEAR_CUSTOMER_SESSION: "/customer/auth/session",
    CREATE_INTERNAL_TRANSACTION: "/transaction/create/internal",
    CREATE_SPEI_TRANSACTION: "/transaction/create/v2",
    FIND_CUSTOMER_BY_CLABE: "/customer/find/clabe?clabe=",
    TRANSACTIONALITY: "/customer/transactionality",
    LISTOFBANK: "/bank/list",
    PAY_CATEGORIES: "/gp/list/categories",
    PAY_PROVIDERS: "/gp/list/providers/v2",
    PAY_SERVICES: "/gp/list/services",
    VERIFY_REFERENCE: "/gp/verify",
    CUSTOMER_BULK_LIST: "/customer/bulk/list",
    CUSTOMER_BULK_TRANSACTIONS_DETAILS:
      "/customer/bulk/transactions/list?transactionGroupId={transactionGroupId}",
    CUSTOMER_BULK_TRANSACTIONS_PENDING:
      "/customer/bulk/pending/list?transactionGroupId={transactionGroupId}",
    CUSTOMER_BULK_ZIP: "/customer/bulk/zip",
    CUSTOMER_TG_FIND: "/tg/find?id={id}",
    CUSTOMER_BULK_CREATE: "/customer/bulk/create",
    CUSTOMER_TRACKING_TX: "/customer/tracking/tx?id=",
    TG_ARCHIVE: "/tg/archive",
    CUSTOMER_BULK_PROCESS: "/customer/bulk/process",
    CUSTOMER_BULK_ITEM: "/customer/bulk/item?id={transactionGroupId}",
    CUSTOMER_BANK_STATEMENT:
      "/account/statement/file?clabe={clabe}&statement={statement}&tokenId={token}",
    GESTOPAGO_PAYMENT: "/gp/pay",
    TRANSACTION_LIST: "/customer/transaction/service/list",
    TRANSACTION_REPORT: "/customer/transaction/report",
    TRANSACTION_SERVICE_LIST: "/customer/transaction/service/list",
    SEARCH_TRANSACTIONS: "/transaction/search",
    TRANSACTION_PDF_RECEIPT: "/transaction/pdf/receipt",
    GENERAL_TERMS: "/user/terms",
    CONTRACT: "/user/contract",
    AGREEMENT_STATUS: "/user/agreement/status",
    CATALOGS: {
      ACTIVIDAD_ECONOMICA: "/catalogs/actividadEconomica",
      ANTECEDENTES: "/catalogs/antecedentes",
      TIEMPO_CONSTITUCION: "/catalogs/tiempoConstitucion",
      RANGO_EDAD: "/catalogs/rangoEdad",
      SEPOMEX: "/catalogs/sepomex", //{cp}
      PAISES: "/catalogs/paises",
      REGIMEN_FISCAL_MORAL: "/catalogs/regimenFiscalMoral",
      REGIMEN_FISCAL_FISICA: "/catalogs/regimenFiscalFisica",
      NACIONALIDAD: "/catalogs/nacionalidad",
      ENTIDAD_FEDERATIVA: "/catalogs/entidadFederativa",
      GENERO: "/catalogs/genero",
      IDENTIFICACION: "/catalogs/identificacion",
      TIPO_RESIDENCIA: "/catalogs/tipoResidencia",
      SERVICIOS_MORAL: "/catalogs/serviciosMoral",
      SERVICIOS_FISICA: "/catalogs/serviciosFisica",
      NUMERO_TRANSACION: "/catalogs/numeroTransaccion",
      MONTOS_TRANSACION: "/catalogs/montosTransaccion",
      BANCOS: "/catalogs/bancos",
      MONTOS_MES_TRANSACION: "/catalogs/montosMesTransaccion",
      ORIGEN_FONDOS: "/catalogs/origenFondos",
      TIPO_CUENTA: "/catalogs/tipoCuenta",
    },
    CLIENTS: {
      CARGA_DOCUMENTOS_MORAL: "/clients/cargaDocumentosMoral", //POST Carga de documentos para moral
      CARGA_DOCUMENTOS_FISICA: "/clients/cargaDocumentosFisica", //POST Carga de documentos para fisica
      FORMULARIO_KYC_MORAL: "/clients/formularioKycMoral", //POST Formulario KYC para cliente moral
      FORMULARIO_KYC_FISICA: "/clients/formularioKycFisica", //POST Formulario KYC para cliente fisica
      DOCUMENTOS_ESTATUS: "/clients/documentosStatus", //GET {clientID} Estatus de los documentos por cliente
      KYC_ESTATUS: "/clients/kycEstatus", //GET {clientID} Estatus del KYC por cliente
      BLOQUEO: "/clients/bloqueo", //POST pendiente de terminar
    },
    TRANSACTIONS: {
      SPEI: "/transactions/tx/spei", //POST transferencia spei
      INTERNAS: "/transactions/tx/internas", //POST transferencia interna
      CUENTAS_FAVORITAS: "/transactions/tx/cuentas/favoritas", //POST {clienteID} agregar cuenta favorita, GET Consulta cuenta favorita (no especifica si lleva clienteID)
      MASIVAS: "/transactions/tx/masivas", //PUT: crear transaccion masiva, POST: ejecutar transaccion masiva
      MASIVAS_LAYOUT: "/transactions/tx/masivas/layout", //POST cargar layout de transaccion masiva
      MASIVAS_IDMASS: "/transactions/tx/masivas/{id_mass}", //GET consultar transaccion masiva
    },
    REPORTS_PLATAFORM: {
      SALDO: "/reportsPlataform/consulta/saldo", //GET {clienteID} Consulta saldo
      CONSULTA_TX: "/reportsPlataform/consulta/tx", //GET Consulta de transaccions (con filtros)
    },
    IDENTITY: {
      REGISTRARSE: "/identity/registrarse", //POST registro de cliente
      OTP_ENVIAR: "/identity/otp/enviar", //POST enviar OTP
      OTP_VALIDAR: "/identity/otp/validar", //POST validar OTP
      CAMBIAR_PASS: "/identity/cambiarPass", //POST cambiar contraseña
      RECUPERAR_PASS: "/identity/recuperarPass", //POST recuperar contraseña
      ACCESO: "/identity/acceso", //POST acceso/login
    },
    WEBHOOKS: {
      CREATE: "/clients/organization/webhook/create", //POST crear configuracion de webhook
      USER_ID: "/clients/organization/webhook", //GET {userID} Obtener a configuracion de webhook
      UPDATE: "/clients/organization/webhook/update", //POST actualizar configuracion de webhook
    }
  },
} as const;

export const INITIAL_CONSTANTS = {
  TITLE: "/landing/login",
} as const;
